import { FC } from "react";
import { Divider, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { InternalBillingExplorerTotalViewGrid } from "./table/InternalBillingExplorerTotalViewGrid";
import { InternalBillingExplorerChartSection } from "./chart/InternalBillingExplorerChartSection";
import { InternalBillingExplorerMetadata } from "./chart/InternalBillingExplorerMetadata";
import {
  ResourceExplorer,
  ResourceExplorerWidget,
} from "@/services/cloudchipr.api";

import { HighchartsProvider } from "@/storybook/c8r-highcharts/common/components/HighchartsProvider";
import ScreenSplitEvenSvgIcon from "@/assets/icons/app-related/ScreenSplitEvenSvgIcon";
import ScreenSplitSvgIcon from "@/assets/icons/app-related/ScreenSplitSvgIcon";

interface InternalResourceExplorerCardProps {
  view: ResourceExplorer;
  viewData?: ResourceExplorerWidget;
  organisationId: string;
}

export const InternalBillingExplorerCard: FC<
  InternalResourceExplorerCardProps
> = ({ view, viewData, organisationId }) => {
  if (!viewData) {
    return null;
  }

  return (
    <Stack pb={1} height="100%" bgcolor="white" overflow="auto">
      <InternalBillingExplorerMetadata viewData={viewData} view={view} />

      <HighchartsProvider>
        <InternalBillingExplorerChartSection
          view={view}
          viewData={viewData}
          dataPoint={view.data.data_point}
          showBudgetLine={view.chart_settings.show_budget_line}
          chartType={view.chart_settings.chart_type}
          chartBase={view.chart_settings.chart_base_type}
        />

        <Stack direction="row" alignItems="center" mt={1}>
          <Divider sx={dividerSx} />

          <ToggleButtonGroup
            exclusive
            size="small"
            value="chart_grid"
            sx={toggleButtonGroupStyles}
          >
            <ToggleButton
              value="chart_grid"
              sx={{ borderRadius: "8px 0 0 8px" }}
            >
              <ScreenSplitEvenSvgIcon fontSize="small" />
            </ToggleButton>

            <ToggleButton value="chart">
              <ScreenSplitSvgIcon fontSize="small" />
            </ToggleButton>

            <ToggleButton value="grid" sx={{ borderRadius: "0 8px 8px 0" }}>
              <ScreenSplitSvgIcon
                fontSize="small"
                sx={{ transform: "rotate(180deg)" }}
              />
            </ToggleButton>
          </ToggleButtonGroup>

          <Divider sx={{ flexGrow: 1 }} />
        </Stack>

        <InternalBillingExplorerTotalViewGrid
          groupBy={view.data.grouping}
          data={viewData}
          organisationId={organisationId}
        />
      </HighchartsProvider>
    </Stack>
  );
};

const toggleButtonGroupStyles = {
  "& .Mui-selected svg": { color: "primary.main" },
};

const dividerSx = { flexGrow: 1 };
